import React, { lazy, Suspense } from 'react';
import type { IStoreState } from '../../common/interfaces/types';
import { reduxConnect } from '../../../common';
import { withScreenSize } from '../../common/utilities/withScreenSize.jsx';

const LazyLoadSmartAppBannerV2 = lazy(() => import('./smartAppBannerV2'));

interface SmartAppBannerLazyLoadProps {
    isDesktop: boolean;
    isBot: boolean;
    enableNewSmartBanner: boolean;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const appState = storeState.appState.appState || {};
    const { user, enableNewSmartBanner } = appState || {};

    return {
        isBot: user?.IsBot,
        enableNewSmartBanner
    };
};

const mapDispatchToProps = {};

export const SmartAppBannerLazyLoaderV2 = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(withScreenSize(({ isDesktop, isBot, enableNewSmartBanner }: SmartAppBannerLazyLoadProps) => {

    if (isBot || isDesktop || !enableNewSmartBanner) {
        return null;
    }

    return (
        <Suspense fallback={<span></span>}>
            <LazyLoadSmartAppBannerV2 />
        </Suspense>
    );
}
)
);